module.exports = {
  "country": "SE",
  "artist": "Eric Saade",
  "song": "Popular",
  "year": "2011",
  "place": "3",
  "spotify": "64WR5TPXZZ2wsWYA3enKfK"
};